(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('offers-popup')) {
    class OffersPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.key = `offers-popup-dismissed-${this.dataset.sectionId}`;

        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-open]')) this.open();
          else if (e.target.closest('[data-close]')) this.close();
        });

        this.dialog.addEventListener('click', (e) => {
          if (this.dataset.closeOnBackdrop === 'true' && e.target === this.dialog) this.close();
        });

        this.dialog.addEventListener('close', () => document.body.style.removeProperty('overflow'));

        // Open when any element on the page links to this popup
        this.onDocClick = (e) => {
          const el = e.target.closest(`[href="#${this.dialog.id}"], [data-offers-popup-open="${this.dataset.sectionId}"]`);
          if (!el) return;
          e.preventDefault();
          this.open();
        };
        document.addEventListener('click', this.onDocClick);

        if (Shopify.designMode) {
          this.onSelect = (e) => {
            if (e.detail.sectionId === this.dataset.sectionId) this.open();
          };
          this.onDeselect = (e) => {
            if (e.detail.sectionId === this.dataset.sectionId) this.close();
          };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
          return;
        }

        if (this.dataset.autoOpen === 'true' && !this.isDismissed()) {
          this.timer = setTimeout(() => this.open(), Number(this.dataset.delay || 5) * 1000);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('click', this.onDocClick);
        if (this.onSelect) {
          document.removeEventListener('shopify:section:select', this.onSelect);
          document.removeEventListener('shopify:section:deselect', this.onDeselect);
        }
      }

      isDismissed() {
        if (this.dataset.remember !== 'true') return false;
        try {
          const until = Number(localStorage.getItem(this.key));
          return until > Date.now();
        } catch (e) {
          return false;
        }
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }

      close() {
        if (!this.dialog.open) return;
        this.dialog.close();
        if (this.dataset.remember === 'true' && !Shopify.designMode) {
          try {
            const days = Number(this.dataset.rememberDays || 1);
            localStorage.setItem(this.key, String(Date.now() + days * 86400000));
          } catch (e) {}
        }
      }
    }

    customElements.define('offers-popup', OffersPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
